import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllClientProject } from "src/thunks/clientProjects";
import _ from "lodash";
import { Search, Close } from "@mui/icons-material";
import { isDropdownOpenFlag } from "src/thunks/dashboard";
import { Tooltip } from "@mui/material";



export const ProjectManagerClientDropdown = ({
    handleChange,
    clientGoodsInDropdownValue,
}) => {
    // useSelector
    const dispatch = useDispatch();
    const clientProjects = useSelector((state) => state?.clientProjects?.clientProject);

    // UseState
    const [filteredData, setFilteredData] = useState([]);
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [searchValue, setSearchValue] = useState("");

    // Variable Declarations
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const filteredClientIds = _.uniqBy(userDetails?.projects?.map((item) => item?.clientId));;
    const filteredArrayForClients = clientProjects?.filter(client => filteredClientIds?.includes(client?.id));
    let dataShown = []

    // Useeffect
    useEffect(() => {
        dataShown = _.orderBy(filteredArrayForClients, ['name'], ["asc"])
        setFilteredData([...dataShown])
    }, [clientProjects])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        dispatch(getAllClientProject());
    }, []);

    useEffect(() => {
        dispatch(isDropdownOpenFlag(open));
    }, [open]);


    // Function declarations
    const onElementClicked = (item) => {
        handleChange(item);
        setOpen((prevOpen) => !prevOpen);
    };
    const onButton = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClearSearchText = () => {
        handleSearchInputChange({ target: { value: "" } });
    };

    const handleSearchInputChange = (e) => {
        setSearchValue(e.target.value)
        const searchTerm = e.target.value.toLowerCase();
        if (searchTerm === '') {
            let d = _.orderBy(filteredArrayForClients, ['name'], ["asc"])
            setFilteredData([...d])
        } else {
            const filtered = filteredData.filter((item) => item.name.toLowerCase().includes(searchTerm));
            let data = _.orderBy(filtered || [], ['name'], ["asc"])
            setFilteredData([...data]);
        }
    };

    return (
        <div ref={dropdownRef}>
            <div className="text-white">
                <div className="mt-3 mt-sm-0 wrapper-pm-dropdown">
                    <div
                        className="d-flex flex-row justify-content-between"
                        onClick={() => onButton()}
                    >
                        <Tooltip title={clientGoodsInDropdownValue?.name == "ALL CLIENTS" ? "" : <span className="project-dropdown-tooltip-style1 project-dropdown-tooltip-style">{`${clientGoodsInDropdownValue.name}`}</span>} arrow>
                            <span className="projectname-wrap">
                                {clientGoodsInDropdownValue?.name}
                            </span>
                        </Tooltip>
                        {open ? (
                            <span className="pe-2">
                                <i className="bi bi-chevron-up chevron-up-arrow"></i>
                            </span>
                        ) : (
                            <span className="pe-2">
                                <i className="bi bi-chevron-down chevron-down-arrow"></i>
                            </span>
                        )}
                    </div>
                    {open && (
                        <>
                            <div className={`content`}>
                                <div style={{ position: "relative", background: "#0045d9" }}>
                                    <input
                                        style={{ position: "relative", width: "100%" }}
                                        className="search-field-input"
                                        type="text"
                                        placeholder="Search by name..."
                                        value={searchValue}
                                        onChange={handleSearchInputChange}
                                    />
                                    {searchValue !== "" ? (
                                        <Close
                                            style={{ cursor: "pointer" }}
                                            onClick={handleClearSearchText}
                                            className="search-icon-depotpersonal-style"
                                        />
                                    ) : (
                                        <Search className="search-icon-depotpersonal-style" />
                                    )}
                                </div>

                                {[{ name: "ALL CLIENTS", value: 0 },...filteredData].map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className={
                                                clientGoodsInDropdownValue?.name === item.name ? `selected-dropdownfield` : ""
                                            }
                                            onClick={() => onElementClicked(item)}
                                        >
                                            {item.name}
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
